/**
 * Shared cart utility functions used across quick-add components and sticky ATC bar.
 */
const CartUtils = {
  async refreshCartDrawer(cartDrawer) {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      const responseText = await response.text();
      const updatedCartDrawer = new DOMParser()
        .parseFromString(responseText, 'text/html')
        .querySelector('cart-drawer');
      if (updatedCartDrawer) cartDrawer.innerHTML = updatedCartDrawer.innerHTML;
    } catch (error) {
      console.error('Error fetching updated cart drawer:', error);
    }
  },

  async getCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return 0;
    }
  },

  updateCartIcon(quantity) {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    [cartBubble].forEach((cartBubble) => {
      let cartCountBubble = cartBubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      let cartCountVisuallyHidden = cartBubble.querySelector('.cart-count-bubble span.visually-hidden');

      if (!cartCountBubble) {
        let container = cartBubble.querySelector('.cart-count-bubble');
        if (!container) {
          container = document.createElement('div');
          container.className = 'cart-count-bubble';
          cartBubble.appendChild(container);
        }
        cartCountBubble = document.createElement('span');
        cartCountBubble.setAttribute('aria-hidden', 'true');
        container.appendChild(cartCountBubble);
      }

      if (!cartCountVisuallyHidden) {
        cartCountVisuallyHidden = document.createElement('span');
        cartCountVisuallyHidden.className = 'visually-hidden';
        cartCountBubble.parentElement.appendChild(cartCountVisuallyHidden);
      }

      cartCountBubble.textContent = quantity;
      cartCountVisuallyHidden.textContent = `${quantity} items`;
    });
  },

  async openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) throw new Error('cart-drawer element not found.');

    const [, cartItemCount] = await Promise.all([
      this.refreshCartDrawer(cartDrawer),
      this.getCartCount(),
    ]);

    // Re-attach overlay click listener (safe - refreshCartDrawer replaces innerHTML,
    // so the overlay is always a fresh node with no existing listeners)
    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', () => cartDrawer.close());
    }

    document.body.classList.add('overflow-hidden');
    cartDrawer.classList.add('active');
    cartDrawer.classList.remove('is-empty');
    this.updateCartIcon(cartItemCount);

    return cartItemCount;
  },
};
